import React, { useEffect, useState } from "react";
import { useReducer } from "react";
import Swal from "sweetalert2";
import { ConsultaCodFornPedidosFornecedor, ConsultaPedidoEncomendaFornecedorRef } from "../../funcionalidades/bancoGet";
import { fillInformation } from "../../subComponents/AtualizarPecasEncomendaReducer";
import ComponentePecaEncomendaRef from '../../subComponents/ComponentePecaEncomendaRef'
import GlobalVar from "../../subComponents/GlobalVar";
import TopMenu from '../../TopMenu'



const AtualizaPecasEncomenda = ({ativaResp, showStyle}) => {

    // const navigate = useNavigate();
    

    useEffect(()=>{
        if(!showStyle) return;
        // import('../../assets/css/auxiliar/scrolbar.css')
        import('../../../assets/css/estiloPaginas/componentePecaEncomendaRef.css')
        import('../../../assets/css/estiloPaginas/atualizaPecasEncomenda.css')
    },[])



    const [notaResult, setNotaResult] = useState([]) 

    const [usuario, setUsuario] = useState(GlobalVar.getSessionStorage('usuario'));
     
    const [stateInfo, dispachInfo] = useReducer(fillInformation, {codigosForn: null, codFornSelecionado: null, produtosForn: null,
    produtosSelecionados: {}})

    useEffect(()=>{
        if(!usuario) return;
        ConsultaCodFornPedidosFornecedor({fornecedor: usuario.fornInfo.for_cod})
                .then((resp)=>{
                  if(resp.Error || resp["ERROR SERVER"]){
                    Swal.fire({
                      type: 'error',
                      title: 'Error',
                      text: 'Sem Pedidos. Servidor Indisponivel, contacte a TI.'
                    })
                  }else{
                    dispachInfo({type: 'codigosForn', value: resp})
                    console.log(resp[0].codigofab)
                    dispachInfo({type: 'codFornSelecionado', value: resp[0].codigofab})
                  }
                })
    },[usuario])


    useEffect(()=>{
        if(!usuario || !stateInfo.codFornSelecionado) return;
        ConsultaPedidoEncomendaFornecedorRef({fornecedor: stateInfo.codFornSelecionado})
                .then((resp)=>{
                  if(resp.Error){
                    Swal.fire({
                      type: 'error',
                      title: 'Error',
                      text: 'Sem Pedidos.'
                    })
                  }else{
                    dispachInfo({type: 'produtosForn', value: resp})
                  }
                })
    },[stateInfo.codFornSelecionado])


    useEffect(()=>{
        if(stateInfo.finalizarSeparacao){
            
        }
    },[stateInfo.finalizarSeparacao])

    if (!usuario) {
        return <div>Carregando...</div>;
      }

    return <>
    <TopMenu ativaResp={ativaResp} showStyle={true}>
    </TopMenu>
            <div className="containerPrincipal atualizaPecasEncomenda" style={{minHeight: "89vh"}}>

            { stateInfo.codFornSelecionado ? <div className="selectContainer">
                {/* <label className="selectLabel">Revista</label> */}
                <select
                    className="selectRev"
                    value={stateInfo.codFornSelecionado}
                    onChange={(e) => dispachInfo({action: 'codFornSelecionado', value: e.target.value})}
                >
                    {stateInfo.codigosForn.map((item) => (
                    <option key={item.codigofab} value={item.codigofab}>
                        {item.rev_nom}
                    </option>
                    ))}
                </select>
            </div> : <></>}


                { (Object.keys(stateInfo.produtosSelecionados).length >= 1) ? 
                    <div className="finalizarBtn" onClick={()=>dispachInfo({type: 'finalizarSeparacao', value: true})}>Finalizar Separação</div> 
                    : <></>}

                <div className={`dataConsulta ${ativaResp ? '' : ''}`}>
                    
                    {stateInfo.produtosForn && stateInfo.produtosForn.length > 0 ? stateInfo.produtosForn.map((val,index) => 
                        <ComponentePecaEncomendaRef item={val} index={index} dispachInfo={dispachInfo} stateInfo={stateInfo}
                    ativaResp={ativaResp}/>) : <></>}
                </div>
        </div>
           </>
}

export default AtualizaPecasEncomenda;
